import app from '@/core/app'
import pinia from '@/core/pinia'
import router from '@/core/router'
import vuestic from '@/core/vuestic'
import gtm from '@/core/gtm'

import { currencyMask } from '@/core/directives'
import { firebaseApp } from '@/core/firebase'
import { VueFire, VueFireAuth } from 'vuefire'

import '@/core/styles/main.scss'

app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
})
app.use(pinia)
app.use(router)
app.use(vuestic)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(gtm)
}

app.directive('currency-mask', currencyMask)

app.mount('#app')
